<template>
  <y-view :loading="isLoading">
    <div>
      <h2 class="mb-1">批次商品</h2>
      <hr class="hr">
      <div class="mt-1" :class="css.show">
        <div :class="css.item">
          贸易模式：{{objInfo.tradeTypeName}}
        </div>
        <div :class="css.item">
          三方货号：{{objInfo.skuCode}}
        </div>
        <div :class="css.item">
          分类：{{objInfo.categoryFirstName}}>{{objInfo.categorySecondName}}>{{objInfo.categoryThirdName}}
        </div>
      </div>
      <div :class="css.show">
        <div :class="css.item">
          条形码：{{objInfo.barCode}}
        </div>
        <div :class="css.item">
          商品名称：{{objInfo.name}}
        </div>
        <div :class="css.item">
          品牌：{{objInfo.brandName}}
        </div>
      </div>
      <div :class="css.show">
        <div :class="css.item">
          商品相册：<template v-if="objInfo.images.length==0">暂无</template> <template v-else>
            <span v-for="(item,index) in objInfo.images" :key="index">
              <a :href="item.url" target="_blank" :title="item.filename">链接{{index+1}}&#12288;</a>
            </span>
          </template>
        </div>
        <div :class="css.item">
          商品详情：<a href="javascript:;" @click="onShowContent">预览</a>
        </div>
        <div :class="css.item">
        </div>
      </div>
    </div>
    <div class="mt-3">
      <h2 class="mb-1">批次供货信息</h2>
      <hr class="hr">
      <div class="mt-1" :class="css.show">
        <div :class="css.item">
          三方批次号：{{objInfo.batchNo}}
        </div>
        <div :class="css.item">
          我方批次号：{{objInfo.saleBatchNo}}
        </div>
      </div>
      <div :class="css.show">
        <div :class="css.item">
          状态：<span class="status-icon" :class="{on:objInfo.isDisabled==0}">{{objInfo.isDisabled==1?'停用':'启用'}}</span>
        </div>
        <div :class="css.item">
          销售渠道：{{objInfo.saleChannelList.map(s=>s.name).join(',')}}
        </div>
      </div>
      <div :class="css.show">
        <div :class="css.item">
          关区：{{objInfo.customs}}
        </div>
        <div :class="css.item">
          批次类型：普通仓
        </div>
      </div>
      <div :class="css.show">
        <div :class="css.item">
          总供货：{{objInfo.totalQuota}}
        </div>
        <div :class="css.item">
          效期：{{objInfo.expiryDate.substring(0,objInfo.expiryDate.lastIndexOf('-'))}}
        </div>
      </div>
      <div :class="css.show">
        <div :class="css.item">
          质量状态：正品
        </div>
      </div>
      <div :class="css.show">
        <div :class="css.item">
          分销商编码：{{objInfo.salesCompanyCode}}
        </div>
      </div>
      <div :class="css.show">
        <div :class="css.item">
          分销商库位编码：{{objInfo.supplierWareSeatCode}}
        </div>
      </div>
      <div :class="css.show">
        <div :class="css.item">
          供应商库位编码：{{objInfo.wscode}}
        </div>
      </div>
      <div :class="css.show">
        <div class="k-tablebox k-tablebox--big k-tablebox--stripe k-tablebox--bordered" style="border-bottom: 0;">
          <div class="k-theadwrapper">
            <table class="k-table k-table--auto">
              <colgroup>
                <col style="width: 120px;">
                <col style="width: 100px;">
                <col style="width: 150px;">
                <col style="width: 84px;">
                <col style="width: 80px;">
              </colgroup>
              <thead>
                <tr>
                  <th style="border-bottom: 1px solid #eaecf0;">货号</th>
                  <th style="border-bottom: 1px solid #eaecf0;">规格</th>
                  <th style="border-bottom: 1px solid #eaecf0;">单价/总价</th>
                  <th style="border-bottom: 1px solid #eaecf0;">最低零售价</th>
                  <th style="border-bottom: 1px solid #eaecf0;">建议零售价</th>
                  <th style="border-bottom: 1px solid #eaecf0;">起购/限购</th>
                  <th style="border-bottom: 1px solid #eaecf0;">是否加入购物车</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(item,index) in objInfo.specList">
                  <tr :key="index">
                    <td :rowspan="objInfo.specList.length" v-if="index==0">
                      {{objInfo.goodsCodeSale}}
                    </td>
                    <td>
                      {{item.quantity}}x{{objInfo.pack}}
                    </td>
                    <td>
                      {{item.unitPrice}}/{{item.totalPrice}}
                    </td>
                    <td>
                      {{item.lowestPrice}}
                    </td>
                    <td>
                      {{item.suggestPrice}}
                    </td>
                    <td>
                      {{item.startQuantity}}/{{item.limitQuantity}}
                    </td>
                    <td>
                      {{item.isAddCart?'是':'否'}}
                    </td>
                  </tr>
                </template>

              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-3">
      <h2 class="mb-1">运费相关</h2>
      <hr class="hr">
      <div class="mt-1">
        <k-table height="200px" :data="objInfo.freightTemplateList" :columns="initColumns()">
        </k-table>
      </div>
    </div>
    <div class="mt-3">
      <h2 class="mb-1">批次资质信息</h2>
      <hr class="hr">
      <div class="mt-1">
        <div :class="css.show">
          <div :class="css.item">
            报关单：{{objInfo.throughCustomsNo}}
            <div>
              <a :href="objInfo.throughCustomsFile" target="_blank"><img style="width: 180px;height: 180px;"
                  :src="objInfo.throughCustomsFile" alt="">
              </a> </div>
          </div>
          <div :class="css.item">
            放行通知书：{{objInfo.customsInspectionNo}}
            <div>
              <a :href="objInfo.customsInspectionFile" target="_blank"><img style="width: 180px;height: 180px;"
                  :src="objInfo.customsInspectionFile" alt=""></a>
            </div>
          </div>
          <div :class="css.item">
            检验检疫报告：{{objInfo.quarantineCertificateNo}}
            <div>
              <a :href="objInfo.quarantineCertificateFile" target="_blank"><img style="width: 180px;height: 180px;"
                  :src="objInfo.quarantineCertificateFile" alt=""></a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <k-popup :show.sync="isShowPopup" class="z-popup" title="商品详情" layout="header,body,close,mask">
      <y-popup-body size="">
        <div :class="css.content-box" style="width: 375px;overflow-y: hidden;">
          <div v-html="objInfo.content"></div>
        </div>
      </y-popup-body>
    </k-popup>
  </y-view>
</template>

<script>
  /**
   * @name:
   * @description: 代发批次查看
   * @author: zhaoliubin@yuouhui.com
   * @create: 2020-09-15 15:16:10
   * @update: 2020-09-15 15:16:10
   */
  export default {
    components: {
    },
    props: {
    },
    computed: {
    },
    watch: {
    },
    data() {
      return {
        isShowPopup: false,
        objInfo: {
          saleChannelList: [],
          specList: [],
          freightTemplateList: [],
          images: []
        },
        id: '',
        isSaving: false,
        isView: false,
        isEdit: false
      };
    },
    methods: {
      initColumns() {
        return [
          {
            name: '区域',
            field: 'region',
            style: {
              width: 164,
              'white-space': 'normal'
            }
          },
          {
            name: '首重（kg)',
            field: 'firstWeight',
            style: {
              width: 60
            }
          },
          {
            name: '首费（元）',
            field: 'firstCost',
            style: {
              width: 60,
              'white-space': 'normal'
            }
          },
          {
            name: '续重（kg)',
            field: 'addWeight',
            style: {
              width: 60
            }
          },
          {
            name: '续费（元）',
            field: 'addCost',
            style: {
              width: 60
            }
          }
        ];
      },
      initPageData() {
        this.isLoading = true;
        this.$fetch({
          api: '/nestle-supply-back-server/wr/detail',
          para: { id: this.id }
        }).then(res => {
          this.isLoading = false;
          this.objInfo = res;
        }).catch(() => {
          this.isLoading = false;
        });
      },
      onShowContent() {
        this.isShowPopup = true;
      }
    },
    created() {
      this.id = this.$route.query.id;
      this.initPageData();
    },
    beforeRouteUpdate(to, from, next) {
      ({ id: this.id, isView: this.isView } = to.query);
      this.initPageData();
    }
  };
</script>

<style lang="postcss" module="css">
  .show {
    display: flex;

    & .item {
      flex: 1;
      padding-right: 10px;
      margin-bottom: 10px;
    }
  }
</style>
